// extracted by mini-css-extract-plugin
export default {"container":"VideoControls__container---IE4x","containerMinimized":"VideoControls__containerMinimized--Q8uR7","controlItem":"VideoControls__controlItem--Vc4ME"};